import * as types from './types';
import { loading, error, success } from 'State/actions';
import { base64ToBlob } from 'Common/IEHelper';
import { change } from 'redux-form';
import { CUSTOM_QUERY_FORM_NAME } from 'Common/FormEnum';
import { CustomQueryEnum } from 'Common/FieldEnum';

export const getQueryCategoryList = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CUSTOM_QUERY_CATEGORY_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `CustomQuery/GetQueryCategories`
      );
      dispatch(
        success(
          types.CUSTOM_QUERY_CATEGORY_LIST,
          response.data.Data ? response.data.Data : []
        )
      );
    } catch (err) {
      dispatch(error(types.CUSTOM_QUERY_CATEGORY_LIST_ERROR, err));
    } finally {
      dispatch(loading(types.CUSTOM_QUERY_CATEGORY_LOADING, false));
    }
  };
};

export const getCustomQueryData = categoryId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `CustomQuery/GetQueries/${categoryId}`
      );
      dispatch(success(types.CUSTOM_QUERY_DATA_LIST, response.data.Data));
    } catch (err) {
      dispatch(error(types.CUSTOM_QUERY_DATA_ERROR, err));
    } finally {
      dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, false));
    }
  };
};

export const setQueryCategory = categoryId => {
  return change(
    CUSTOM_QUERY_FORM_NAME,
    CustomQueryEnum.QueryCategory,
    categoryId
  );
};

export const setCustomQueryData = query => {
  return dispatch => {
    dispatch(change(CUSTOM_QUERY_FORM_NAME, CustomQueryEnum.Query, query));
  };
};

export const setCustomDescriptionData = description => {
  return dispatch => {
    dispatch(
      change(CUSTOM_QUERY_FORM_NAME, CustomQueryEnum.Description, description)
    );
  };
};

export const resetCategoryOnRemove = () => {
  return dispatch => {
    dispatch(change(CUSTOM_QUERY_FORM_NAME, CustomQueryEnum.QueryCategory, 1));
  };
};

export const setCategoryOnEdit = selectedCategoryDescription => {
  return dispatch => {
    dispatch(
      change(
        CUSTOM_QUERY_FORM_NAME,
        CustomQueryEnum.QueryCategoryText,
        selectedCategoryDescription
      )
    );
  };
};

export const clearCategoryText = () => {
  return dispatch => {
    dispatch(
      change(CUSTOM_QUERY_FORM_NAME, CustomQueryEnum.QueryCategoryText, '')
    );
  };
};

export const deleteQuery = (categoryId, queryId) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(
        `CustomQuery/RemoveQuery/${categoryId}/${queryId}`
      );
      dispatch(success(types.CUSTOM_QUERY_DELETE_SUCCESS));
    } catch (err) {
      dispatch(error(types.CUSTOM_QUERY_DELETE_ERROR, err));
    } finally {
      dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, false));
    }
  };
};

export const deleteQueryCategory = categoryId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        `CustomQuery/RemoveQueryCategory/${categoryId}`
      );
      dispatch(success(types.CUSTOM_QUERY_CATEGORY_DELETE_SUCCESS));
    } catch (err) {
      dispatch(error(types.CATEGORY_DELETE_ERROR, err));
    } finally {
      dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, false));
    }
  };
};

export const clearQueryError = () => {
  return {
    type: types.CLEAR_QUERY_ERROR,
  };
};

export const saveCategory = category => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        'CustomQuery/SaveQuryCategory',
        category
      );
      dispatch(success(types.CATEGORY_SAVE_SUCCESS));
    } catch (err) {
      dispatch(error(types.CATEGORY_SAVE_ERROR, err));
    } finally {
      dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, false));
    }
  };
};

export const setNewCategory = category => ({
  type: types.CUSTOM_QUERY_SET_NEW_CATEGORY,
  payload: category,
});

export const saveQuery = queryObject => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        'CustomQuery/SaveQuery',
        queryObject
      );
      dispatch(success(types.CUSTOM_QUERY_SAVE_SUCCESS));
    } catch (err) {
      dispatch(error(types.CUSTOM_QUERY_SAVE_ERROR, err));
    } finally {
      dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, false));
    }
  };
};

export const executeCustomQuery = queryObject => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'CustomQuery/ExecuteQuery',
        queryObject
      );
      const { FileName, Stream } = response.data.Data.FileInfo;
      eleFileGeneration(FileName, Stream);
      dispatch(success(types.CUSTOM_QUERY_EXECUTE_SUCCESS));
    } catch (err) {
      dispatch(error(types.CUSTOM_QUERY_EXECUTE_ERROR, err));
    } finally {
      dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, false));
    }
  };
};

const eleFileGeneration = (fileName, fileData) => {
  const blob = base64ToBlob(fileData, 'application/octet-stream');
  const URL = window.URL || window.webkitURL || window.mozURL;
  const downloadUrl = URL.createObjectURL(blob);
  if (fileName) {
    const a = document.createElement('a');
    if (typeof a.download === 'undefined') {
      window.location = downloadUrl;
    } else {
      a.href = downloadUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  } else {
    window.location = downloadUrl;
  }
};

export const downloadCustomQuery = (categoryId, queryId) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `CustomQuery/DownloadQuery/${categoryId}/${queryId}`
      );
      const { FileName, Stream } = response.data.Data;
      eleFileGeneration(FileName, Stream);
    } catch (err) {
      dispatch(error(types.CUSTOM_QUERY_DOWNLOAD_ERROR, err));
    } finally {
      dispatch(loading(types.CUSTOM_QUERY_DATA_LOADING, false));
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/customQueries/action.js